var _defs, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLavoroIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Group_30787",
    "data-name": "Group 30787",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.114,
    x2: 1,
    y2: 0.864,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#442eb2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#d8583d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fa9c2b"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_15935",
    "data-name": "Path 15935",
    d: "M0,0H36A12,12,0,0,1,48,12v4.8H12A12,12,0,0,1,0,4.8Z",
    transform: "translate(0 31.2)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Union_632",
    "data-name": "Union 632",
    d: "M16.8,16.8V1.22a13.88,13.88,0,0,0,3.727,9.074C24.728,14.494,33.6,16.8,33.6,16.8Zm-4.8,0A12,12,0,0,1,0,4.8V0H16.8V16.8Z",
    transform: "translate(7.2 31.2)",
    fill: "url(#linear-gradient)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Union_634",
    "data-name": "Union 634",
    d: "M16.8,16.8V1.22a13.88,13.88,0,0,0,3.727,9.074C24.728,14.494,33.6,16.8,33.6,16.8Zm-4.8,0A12,12,0,0,1,0,4.8V0H16.8V16.8Z",
    transform: "translate(3.6 31.2)",
    fill: "url(#linear-gradient)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Union_633",
    "data-name": "Union 633",
    d: "M16.8,48V32.42a13.882,13.882,0,0,0,3.727,9.074C24.728,45.693,33.6,48,33.6,48ZM12,48A12,12,0,0,1,0,36V0H4.8a12,12,0,0,1,12,12V48Z",
    transform: "translate(0)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLavoroIcon);
export default __webpack_public_path__ + "static/media/lavoro-icon.717fb9200b0debb4d5fade37ca69eae0.svg";
export { ForwardRef as ReactComponent };